var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v("促销")]),_c('el-breadcrumb-item',[_vm._v("促销历史")])],1),_c('promotion-list',{attrs:{"type":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }